export const PROGRAMS = `
  query programs(
    $skip: Int
    $take: Int
    $orderBy: ProgramOrderInput
    $filter: FilterProgramInput
    $searchText: String
    $tenant_id: Int!
  ) {
    programs(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
      tenant_id: $tenant_id
    ) {
      __typename

      ... on Program {
        id
        name
        category_id
        category {
          id
          name
        }
        region_id
        region {
          id
          name
        }
        key_group
        budget
        include
        link
        monthly_fee
        signup
        active
        humand_exclude
        interior
        province_id
        province {
          id
          name
        }
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
        pricings {
          id
          program_variant_id
          vistage_group_id
          monthly_fee
          signup
          budget
          expenses
          valid_to
          is_active
          its
          uts
          dts
          created_by
          updated_by
          deleted_by
          variant {
            id
            name
            active
            scope
            program_category_id
            category {
              id
              name
            }
          }
        }
      }

      ... on ResultError {
        message
      }
    }
  }
`;

export const PROGRAMS_COUNT = `
  query programsCount(
    $filter: FilterProgramInput
    $searchText: String
    $tenant_id: Int!
  ) {
    programsCount(
      filter: $filter
      searchText: $searchText
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
